<template>
  <Layout
    contentClass="general"
    bgImg="default"
    pageTitle=""
    pageTitleIcon=""
    :step="2"
    :fixedPhone="true"
    :loading="false"
  >
    <div class="form bilgi-label" style="border-top: solid 10px #1cc54e">
      <div class="item">
        <div class="result success">
          <div class="icon">
            <span style="margin-left: 0px"></span>
          </div>
        </div>
      </div>
      <div class="item">
        <h2 style="font-size: 1.5em">Talebiniz Alınmıştır.</h2>
        <p>
          Fiyat çalışmanız hazırlanıyor. En kısa sürede sizinle iletişime
          geçilecektir. <br />
          Teşekkür ederiz.
        </p>
      </div>
      <div class="item">
        <div class="submit">
          <ul>
            <li>
              <!-- <button @click="this.goToHome()" class="button green-btn">
                ANA SAYFA
              </button> -->
              <a href="https://www.axasigorta.com.tr/" class="button green-btn">
                ANA SAYFA
              </a>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </Layout>
</template>

<script>
import router from "@/routes";
import { store } from "@/store";

export default {
  data() {
    return {
      store,
    };
  },
  methods: {
    goToHome() {
      window.dataLayer.push({
        event: "gaEvent",
        page_path: "/talebiniz-alinmistir",
        event_category: "Kotasyon Form Home",
        event_action: "Dijital Saglik Sigortasi",
        event_label: "Ana Sayfa",
      });

      //   console.log("gtm test", window, window.dataLayer);

      router.push({
        name: "Bilgiler",
      });
    },
  },
};
</script>
